import { createClient } from "../../prismicio";
import { TrainingCalendar } from "@/components";
import { useEffect, useState } from "react";
import prisma from "@/Utility/prisma";
import { Meta } from "@/components";

export default function HubPage({ trainingHubDocument, courseDocuments }) {
	const [courses, setCourses] = useState(false);
	useEffect(() => {
		fetch("/api/admin-db/get-published-courses")
			.then((response) => response.json())
			.then((data) => {
				// Find the path/uid of the document in Prismic associated with course and add to publishedCourses object
				data = data?.map((course) => {
					// Find the corresponding course document
					const courseDocument = courseDocuments.find(
						(doc) => doc.data.course_id === course.templateId
					);

					console.debug("Matched Course Document: ");
					console.debug(courseDocument);

					// If a corresponding course document is found, add its URL to the course object
					if (courseDocument) {
						course.url = courseDocument.url;
					}

					return {
						...course,
					};
				});
				setCourses(data);
			})
			.catch((error) => console.error("Error:", error));
	}, []);
	return (
		<>
			<Meta
				metaTitle={trainingHubDocument?.data?.meta_title}
				metaDescription={trainingHubDocument?.data?.meta_description}
				socialShareImage={trainingHubDocument?.data?.meta_image?.url}
			/>
			<main>
				<TrainingCalendar courses={courses}></TrainingCalendar>
			</main>
		</>
	);
}

export async function getServerSideProps({ previewData }) {
	const client = createClient({ previewData });

	// Use Prismic client to get content
	const nav = await client.getSingle("nav");
	const footer = await client.getSingle("footer");
	const courseDocuments = await client.getAllByType("course");
	const trainingHubDocument = await client.getSingle("training_hub");

	// console.debug("Course Documents: ");
	// console.debug(courseDocuments);

	return {
		props: {
			nav,
			footer,
			courseDocuments,
			trainingHubDocument,
		},
	};
}
